<ng-container *transloco="let t">
    <!-- Breadcrumb -->
    <div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
        <h5 class="mb-0">
            {{t('edit')}} {{t('vulnerability')}}
        </h5>
        <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
            <li class="breadcrumb-item position-relative">
                {{t('Assessments')}}
            </li>
            <li class="breadcrumb-item position-relative">
                <a routerLink="/vulnerability/assessments" class="d-inline-block position-relative">
                    {{t('Management')}}
                </a>
            </li>
            <li class="breadcrumb-item position-relative">
                <a routerLink="/vulnerability/view-vulnerabilities/{{vulnerabilityAssessmentId}}"
                    class="d-inline-block position-relative">
                    {{t('Vulnerabilities')}}
                </a>
            </li>
            <li class="breadcrumb-item position-relative">
                {{t('edit')}} {{t('vulnerability')}}
            </li>
        </ol>
    </div>

    <!-- Edit Vulnerability -->
    <mat-card class="altair-card create-company-card mb-25 border-radius bg-white border-none d-block"
        [class.rtl-enabled]="themeService.isRTLEnabled()">
        <mat-card-content>
            <form [formGroup]="editVulnerabilityForm">
                <div class="row">
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('name')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('enter-name')}}
                                </mat-label>
                                <input matInput type="text" formControlName="name" [(ngModel)]="editVulnerability.name">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('reference-code')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('enter-reference-code')}}
                                </mat-label>
                                <input matInput type="text" id="referenceCode" formControlName="referenceCode"
                                    [(ngModel)]="editVulnerability.referenceCode">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('expected-resolution-date')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('choose-a-date')}}
                                </mat-label>
                                <input matInput [matDatepicker]="erd" formControlName="expectedResolutionDate"
                                    [(ngModel)]="editVulnerability.expectedResolutionDate">
                                <mat-hint>DD/MM/YYYY</mat-hint>
                                <mat-datepicker-toggle matIconSuffix [for]="erd"></mat-datepicker-toggle>
                                <mat-datepicker #erd [disabled]="!isInternal"></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('description')}}
                            </label>
                            <mat-form-field class="textarea">
                                <mat-label>
                                    {{t('enter-description')}}
                                </mat-label>
                                <textarea matInput type="text" id="description" formControlName="description"
                                    [(ngModel)]="editVulnerability.description"></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('impact')}}
                            </label>
                            <mat-form-field class="textarea">
                                <mat-label>
                                    {{t('enter-impact')}}
                                </mat-label>
                                <textarea matInput type="text" id="impact" formControlName="impact"
                                    [(ngModel)]="editVulnerability.impact"></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('recommendation')}}
                            </label>
                            <mat-form-field class="textarea">
                                <mat-label>
                                    {{t('enter-recommendation')}}
                                </mat-label>
                                <textarea matInput type="text" id="recommendation" formControlName="recommendation"
                                    [(ngModel)]="editVulnerability.recommendation"></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('get-help')}}
                            </label>
                            <mat-form-field>
                                <textarea matInput id="help" formControlName="help" [(ngModel)]="help"></textarea>
                                <button matSuffix mat-icon-button class="altair" (click)="searchHelp()"
                                    [disabled]="help.length > 0">
                                    <mat-icon class="material-symbols-outlined">
                                        help
                                    </mat-icon>
                                </button>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('port')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('enter-port')}}
                                </mat-label>
                                <input matInput type="number" id="port" formControlName="port"
                                    (keydown.e)="onKeydown($event)" [(ngModel)]="editVulnerability.port">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('resolution-date')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('choose-a-date')}}
                                </mat-label>
                                <input matInput [matDatepicker]="rd" formControlName="resolutionDate"
                                    [(ngModel)]="editVulnerability.resolutionDate">
                                <mat-hint>DD/MM/YYYY</mat-hint>
                                <mat-datepicker-toggle matIconSuffix [for]="rd"></mat-datepicker-toggle>
                                <mat-datepicker #rd [disabled]="!isInternal"></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('protocol')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('enter-protocol')}}
                                </mat-label>
                                <input matInput type="text" id="protocol" formControlName="protocol"
                                    [(ngModel)]="editVulnerability.protocol">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('state')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('select-state')}}
                                </mat-label>
                                <mat-select formControlName="state" [(value)]="selectedState"
                                    [(ngModel)]="editVulnerability.state" required="true">
                                    <mat-option *ngFor="let state of states" [value]="state">
                                        {{state.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('vulnerability-date')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('choose-a-date')}}
                                </mat-label>
                                <input matInput [matDatepicker]="vd" formControlName="vulnerabilityDate"
                                    [(ngModel)]="editVulnerability.vulnerabilityDate">
                                <mat-hint>DD/MM/YYYY</mat-hint>
                                <mat-datepicker-toggle matIconSuffix [for]="vd"></mat-datepicker-toggle>
                                <mat-datepicker #vd [disabled]="!isInternal"></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('asset')}}
                            </label>
                            <mat-form-field>
                                <input type="text" placeholder="{{t('search')}} {{t('asset')}}..." matInput
                                    [formControl]="assetControl" [matAutocomplete]="auto"
                                    [(ngModel)]="editVulnerability.asset" required="true">
                                <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption
                                    [displayWith]="displayFn">
                                    @for (asset of filteredAssets | async; track asset) {
                                    <mat-option [value]="asset">{{asset.name}}</mat-option>
                                    }
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('score')}}
                            </label>
                            <mat-form-field>
                                <input matInput type="number" id="score" formControlName="score"
                                    [(ngModel)]="editVulnerability.score">
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <div class="btn-box">
                    <a mat-button
                        routerLink="/vulnerability/view-evidences/{{vulnerabilityAssessmentId}}/{{vulnerabilityAssessmentResultId}}">
                        {{t('view')}} {{t('evidences')}}
                    </a>
                    @if(roleName != specialist){
                    <a mat-button
                        routerLink="/vulnerability/manage-vulnerability/{{vulnerabilityAssessmentId}}/{{vulnerabilityAssessmentResultId}}">
                        {{t('manage')}} {{t('vulnerability')}}
                    </a>
                    }
                    @else {
                    <button mat-button type="button" (click)="changeStateAndManageVulnerability()">
                        {{t('manage')}} {{t('vulnerability')}}
                    </button>

                    }

                </div>

                <div class="row">
                    <p></p>
                    <mat-card-header>
                        <mat-card-title>
                            BASE SCORE
                        </mat-card-title>
                    </mat-card-header>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                Attack Vector
                            </label>
                            <mat-button-toggle-group name="attackVector" formControlName="attackVector"
                                [hideSingleSelectionIndicator]="true" [(ngModel)]="attackVector"
                                (change)="onValChange('attackVector',$event.value)">
                                <mat-button-toggle value="N">Network</mat-button-toggle>
                                <mat-button-toggle value="A">Adjacent</mat-button-toggle>
                                <mat-button-toggle value="L">Local</mat-button-toggle>
                                <mat-button-toggle value="P">Physical</mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                Attack Complexity
                            </label>
                            <mat-button-toggle-group name="attackComplexity" formControlName="attackComplexity"
                                [hideSingleSelectionIndicator]="true" [(ngModel)]="attackComplexity"
                                (change)="onValChange('attackComplexity',$event.value)">
                                <mat-button-toggle value="L">Low</mat-button-toggle>
                                <mat-button-toggle value="H">High</mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                Privileges Required
                            </label>
                            <mat-button-toggle-group name="privilegesRequired" formControlName="privilegesRequired"
                                [hideSingleSelectionIndicator]="true" [(ngModel)]="privilegesRequired"
                                (change)="onValChange('privilegesRequired',$event.value)">
                                <mat-button-toggle value="N">None</mat-button-toggle>
                                <mat-button-toggle value="L">Low</mat-button-toggle>
                                <mat-button-toggle value="H">High</mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                User Interaction
                            </label>
                            <mat-button-toggle-group name="userInteraction" formControlName="userInteraction"
                                [hideSingleSelectionIndicator]="true" [(ngModel)]="userInteraction"
                                (change)="onValChange('userInteraction',$event.value)">
                                <mat-button-toggle value="N">None</mat-button-toggle>
                                <mat-button-toggle value="R">Required</mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                Scope
                            </label>
                            <mat-button-toggle-group name="scope" formControlName="scope"
                                [hideSingleSelectionIndicator]="true" [(ngModel)]="scope"
                                (change)="onValChange('scope',$event.value)">
                                <mat-button-toggle value="U">Unchanged</mat-button-toggle>
                                <mat-button-toggle value="C">Changed</mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                Confidentiality
                            </label>
                            <mat-button-toggle-group name="confidentiality" formControlName="confidentiality"
                                [hideSingleSelectionIndicator]="true" [(ngModel)]="confidentiality"
                                (change)="onValChange('confidentiality',$event.value)">
                                <mat-button-toggle value="N">None</mat-button-toggle>
                                <mat-button-toggle value="L">Low</mat-button-toggle>
                                <mat-button-toggle value="H">High</mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                Integrity
                            </label>
                            <mat-button-toggle-group name="integrity" formControlName="integrity"
                                [hideSingleSelectionIndicator]="true" [(ngModel)]="integrity"
                                (change)="onValChange('integrity',$event.value)">
                                <mat-button-toggle value="N">None</mat-button-toggle>
                                <mat-button-toggle value="L">Low</mat-button-toggle>
                                <mat-button-toggle value="H">High</mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                Availability
                            </label>
                            <mat-button-toggle-group name="availability" formControlName="availability"
                                [hideSingleSelectionIndicator]="true" [(ngModel)]="availability"
                                (change)="onValChange('availability',$event.value)">
                                <mat-button-toggle value="N">None</mat-button-toggle>
                                <mat-button-toggle value="L">Low</mat-button-toggle>
                                <mat-button-toggle value="H">High</mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>
                </div>

                <div class="btn-box">
                    <button mat-button type="button" (click)="onSubmit()" [disabled]="editVulnerabilityForm.invalid">
                        {{t('save')}} {{t('vulnerability')}}
                    </button>
                    <a mat-button routerLink="/vulnerability/view-vulnerabilities/{{vulnerabilityAssessmentId}}">
                        {{t('cancel')}}
                    </a>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-container>
